'use strict'

// utility class
import ApplyClass from '../Utils/ApplyClass'

import Form from '../Controller/Form'

import Validate from '../View/Form/Validate';
import FileUpload from '../View/Form/FileUpload';
import Submit from '../View/Form/Submit';
import Agree from '../View/Form/Agree';
import RequiredRestNum from '../View/Form/RequiredRestNum';
import FormPasswordView from '../View/Form/FormPasswordView';
import AddResumeArea from '../View/Form/AddResumeArea';
import InputActivation from '../View/Form/InputActivation';
import CheckBoxToggle from '../View/Form/CheckBoxToggle';
import Select2 from '../View/Form/Select2';
import DeactivationCheckbox from '../View/Form/DeactivationCheckbox';
import ImageRotate from '../View/Form/ImageRotate'
import LoginForm from '../View/Form/LoginForm';

// import ZenkakuToHankaku from '../View/Form/ZenkakuToHankaku';
// import HasCounter from '../View/Form/HasCounter';
// import Select2Wide from '../View/Form/Select2Wide';
// import DatePicker from '../View/Form/DatePicker';
// import DeleteItem from '../View/Form/DeleteItem';
// import CheckAll from '../View/Form/CheckAll';
// import CatchCopy from '../View/Form/CatchCopy';
// import ChangeDisplayType from '../View/Form/ChangeDisplayType';

$(() => {
	const FormController = new Form()

	// // メールのデフォルト設定
	// $('.anchor--contact-mail').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(MailerSettings, $e, [$e, FormController]);
	// });
	// validate;
	$('.validate').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Validate, $e, [$e, FormController])
	})
	// // 全角→半角変換
	// $(".zen2han").each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(ZenkakuToHankaku, $e, [$e, FormController]);
	// });
	// // カウンター
	// $('.has-counter').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(HasCounter, $e, [$e, FormController]);
	// });
	// submit;
	$('[type=submit][data-form]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Submit, $e, [$e, FormController])
	})
	// ファイルアップロード
	$('.file-upload').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FileUpload, $e, [$e, FormController]);
	});
	// 規約に同意
	$('#agree').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Agree, $e, [$e, FormController]);
	});
	// 必須項目カウント
	$('.required').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(RequiredRestNum, $e, [$e, FormController]);
	});
	// パスワードを表示する
	$('.anchor--show-password').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormPasswordView, $e, [$e, FormController]);
	});
	// 履歴書 職種、資格エリア追加
	$('.btn--add-resume-area').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AddResumeArea, $e, [$e, FormController]);
	});
	// テキスト入力でボタンを活性化
	$('[data-input-activation-type="wrap"]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(InputActivation, $e, [$e, FormController])
	});
	// チェックボックスにチェックするとターゲットが開閉する
	$('[type=checkbox][data-target-toggle]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(CheckBoxToggle, $e, [$e, FormController])
	});
	// select2
	$('.select2').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Select2, $e, [$e, FormController]);
	});
	// チェックボックスの非活性化
	$('.deactivation[data-target]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeactivationCheckbox, $e, [$e, FormController]);
	});
	// 掲示板画像回転
	$('[data-rotate=90]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ImageRotate, $e, [$e, FormController])
	})
	$('[data-rotate=270]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ImageRotate, $e, [$e, FormController])
	})
	// ログイン画面のパラメータを取得し、return urlにセット
	$('#form-login').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(LoginForm, $e, [$e, FormController]);
	});

	// // select2
	// $('.select2-wide').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(Select2Wide, $e, [$e, FormController]);
	// });
	// // Air  Datepicker
	// $('[data-datepicker=true]').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(DatePicker, $e, [$e, FormController]);
	// });
	// // アイテム削除
	// $('.btn-delete-item').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(DeleteItem, $e, [$e, FormController]);
	// });
	// // 全てチェックする
	// $('.check-all').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(CheckAll, $e, [$e, FormController]);
	// });
	// // 全てチェックする
	// $('.input-dummy').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(CatchCopy, $e, [$e, FormController]);
	// });
	// // 表示タイプ変更
	// $('.display_type').each((idx, e) => {
	// 	const $e = $(e);
	// 	ApplyClass.apply(ChangeDisplayType, $e, [$e, FormController]);
	// });
})
